import React, { FC, memo } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';

interface Props {
  title: string;
  onPress: () => void;
}

const Button = styled.TouchableOpacity`
  min-width: 42%;
  max-width: 48%;
  padding-vertical: 12px;
  padding-horizontal: 16px;
  background-color: ${Colors.MAIN_COLOR};
  border-radius: 10px;
`;

const ButtonText = styled(Fonts.Bold)`
  color: ${Colors.WHITE};
  text-align: center;
  font-size: 16px;
  width: 100%;
`;

const PrimaryButton: FC<Props> = ({ title, onPress }) => {
  return (
    <Button onPress={onPress} accessibilityRole="button">
      <ButtonText>{title}</ButtonText>
    </Button>
  );
};

export default memo(PrimaryButton);
